import 'ui-core/widgets/cookie-policy-popup/js/cookie-policy-popup';

let whenClosed,
    cookiePopup = document.querySelector('.cookiePolicy-popup');

if (cookiePopup !== null) {
    whenClosed = e => {
        setTimeout(() => {
            UX.stickyElements.init();
        }, 250);
    };
    let agree = cookiePopup.querySelector('#accept-cookie-policy');
    let close = cookiePopup.querySelector('.cookiePolicy-popup__close');

    agree.addEventListener('click', whenClosed);
    close.addEventListener('click', whenClosed);
}
